import React, { useRef } from "react"
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material"
import SurfboardSvg from "./SurfboardSvg"

const CustomOrderSurfboards = ({
  selectedLogoOption,
  selectedDeckPatchOption,
  selectedDeckColorOption,
  selectedBottomColorOption,
  selectedTailPatchOption,
  selectedFinBoxColorOption,
  selectedFinSetupOption,
  selectedNoseShapeOption,
  selectedTailShapeOption,
  selectedPinLineColorOption,
  selectedLengthOption,
  selectedWidthOption,
  selectedStringerTypeOption,
  selectedNumberOfStringersOption,
}) => {
  const surfboardDeckSvgRef = useRef(null)
  const surfboardBottomSvgRef = useRef(null)
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"))

  const panelContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      {/* Labels */}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          maxWidth: { xs: 480, lg: 560, xl: 660 },
          gap: { xs: 2, md: 3 },
        }}
      >
        <Typography
          variant="overline"
          sx={{
            flex: 1,
            textAlign: "center",
            color: "#c8b99a",
            letterSpacing: "0.25em",
            fontSize: "0.65rem",
            fontFamily: "'Josefin Sans', sans-serif",
          }}
        >
          Deck
        </Typography>
        <Typography
          variant="overline"
          sx={{
            flex: 1,
            textAlign: "center",
            color: "#c8b99a",
            letterSpacing: "0.25em",
            fontSize: "0.65rem",
            fontFamily: "'Josefin Sans', sans-serif",
          }}
        >
          Bottom
        </Typography>
      </Box>

      {/* SVG container */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 2, md: 3 },
          maxWidth: { xs: 480, lg: 560, xl: 660 },
          width: "100%",
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <SurfboardSvg
            svgRef={surfboardDeckSvgRef}
            style={{ width: "100%", height: "75vh", maxHeight: "700px" }}
            selectedLogoOption={selectedLogoOption}
            selectedDeckPatchOption={selectedDeckPatchOption}
            selectedDeckColorOption={selectedDeckColorOption}
            selectedBottomColorOption={selectedBottomColorOption}
            selectedTailPatchOption={selectedTailPatchOption}
            selectedFinBoxColorOption={selectedFinBoxColorOption}
            selectedFinSetupOption={selectedFinSetupOption}
            selectedNoseShapeOption={selectedNoseShapeOption}
            selectedTailShapeOption={selectedTailShapeOption}
            selectedPinLineColorOption={selectedPinLineColorOption}
            selectedLengthOption={selectedLengthOption}
            selectedWidthOption={selectedWidthOption}
            selectedStringerTypeOption={selectedStringerTypeOption}
            selectedNumberOfStringersOption={selectedNumberOfStringersOption}
            deck={true}
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <SurfboardSvg
            svgRef={surfboardBottomSvgRef}
            style={{ width: "100%", height: "75vh", maxHeight: "700px" }}
            selectedLogoOption={selectedLogoOption}
            selectedDeckPatchOption={selectedDeckPatchOption}
            selectedDeckColorOption={selectedDeckColorOption}
            selectedBottomColorOption={selectedBottomColorOption}
            selectedTailPatchOption={selectedTailPatchOption}
            selectedFinBoxColorOption={selectedFinBoxColorOption}
            selectedFinSetupOption={selectedFinSetupOption}
            selectedNoseShapeOption={selectedNoseShapeOption}
            selectedTailShapeOption={selectedTailShapeOption}
            selectedPinLineColorOption={selectedPinLineColorOption}
            selectedLengthOption={selectedLengthOption}
            selectedWidthOption={selectedWidthOption}
            selectedStringerTypeOption={selectedStringerTypeOption}
            selectedNumberOfStringersOption={selectedNumberOfStringersOption}
          />
        </Box>
      </Box>

      {/* Disclaimer */}
      <Typography
        variant="caption"
        sx={{
          color: "#7ea8be",
          fontFamily: "'Josefin Sans', sans-serif",
          fontSize: "0.7rem",
          letterSpacing: "0.05em",
          textAlign: "center",
        }}
      >
        Finbox placement and outline not completely accurate
      </Typography>
    </Box>
  )

  if (isDesktop) {
    return (
      <>
        {/* Spacer to hold grid space */}
        <Grid item md={7} sx={{ visibility: "hidden" }}>
          {panelContent}
        </Grid>
        {/* Fixed panel that follows the viewport */}
        <Box
          sx={{
            position: "fixed",
            top: "280px",
            left: 0,
            height: "calc(100vh - 280px)",
            width: "58.333%", /* 7/12 of container */
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            zIndex: 1,
            px: 3,
          }}
        >
          <Box sx={{ pointerEvents: "auto", width: "100%", maxWidth: { md: 520, lg: 600, xl: 700 } }}>
            {panelContent}
          </Box>
        </Box>
      </>
    )
  }

  return (
    <Grid item xs={12}>
      {panelContent}
    </Grid>
  )
}

export default CustomOrderSurfboards
